<template>
    <div class="personalMain">
      <p class="current">当前位置：<span>个人中心</span><i class="el-icon-arrow-right"></i><span>绑定银行卡</span></p>
      <div class="personal-box">
        <personalMenu></personalMenu>
        <div class="MainInfo">
            <p class="currTitle">{{ status == true ? '您已绑定银行卡': '绑定银行卡' }}</p>
               
            <div  class="bookingItems">
                <div class="address-info" >
                   <div v-show="!status">
                        <el-form :model="ruleForm"  ref="ruleForm" 
                            :label-width="widthNew?'120px':'26%'">
                            <el-form-item label="姓名">
                                <el-input v-model="ruleForm.name" placeholder="请输入您的姓名" ></el-input>
                            </el-form-item>
                            
                            <el-form-item label="手机">
                                <el-input v-model="ruleForm.phone" placeholder="请填写银行卡预留手机号码"></el-input>
                            </el-form-item>
                        
                            <el-form-item label="开户银行" >
                                <el-input placeholder="请填写开户银行名称"   v-model="ruleForm.bank_name"></el-input>
                            </el-form-item>
                            <el-form-item label="银行卡号" >
                                <el-input placeholder="请填写正确的银行卡号" v-model="ruleForm.card_number"></el-input>
                                
                            </el-form-item>
                            <el-form-item label="确认卡号" >
                                <el-input placeholder="请再次填写银行卡号" v-model="ruleForm.vsCard_number"></el-input>
                                
                            </el-form-item>
<!--                             
                            <el-form-item style="border: none;">
                               
                            </el-form-item> -->
                        </el-form>
                        <div style="border: none;">
                            <el-button type="primary" class="restButtonForget" @click="handleCardUpdateUser">立即绑定</el-button>
                        </div>
                        <span class="tipsSpan">温馨提示：</span>
                        <p class="tipsP">请填写真实姓名、正确的银行卡信息，否则将无法成功提现</p>
                   </div>
                   <div v-show="status">
                        <div class="cardUserInfo">
                            <p>姓名：</p>
                            <span>{{ cardInfo.name }}</span>
                        </div>
                        <div  class="cardUserInfo">
                            <p>手机：</p>
                            <span>{{ cardInfo.phone }}</span>
                        </div>
                        <div  class="cardUserInfo">
                            <p>开户银行：</p>
                            <span>{{ cardInfo.bank_name }}</span>
                        </div>
                        <div class="cardUserInfo">
                            <p>银行卡号：</p>
                            <span>{{ cardInfo.card_number }}</span>
                        </div>
                        <div >
                            <el-button type="primary" class="restButtonForget" @click="status = false">重新绑定</el-button>
                        </div>

                   </div>
                </div>
        
            </div>
        </div>
      </div>
    </div>
  </template>
  
<script>
import personalMenu from './index.vue'
export default {
    data(){
        return{
            vsData: [],
            total: 0,
            hideOnSinglePage: true,
            ruleForm: {
                name: '',
                phone: '',
                bank_name: '',
                card_number: '',
                vsCard_number: ''
            },
            status: '',
            cardInfo: {},
            widthNew: false
        
        }
    },
    components:{
        personalMenu
    },
    methods: {
        listByUser(){
            this.$store.dispatch('personal/CardInfoByUser')
            .then(res => {
                if(res.ok){
                   this.status = true
                   this.cardInfo = res.data
                   
                }else{
                    this.status = false
                }
            })
        },
        handleCardUpdateUser(){
           if(this.ruleForm.vsCard_number != this.ruleForm.card_number){
                this.$alert('两次输入的银行卡号不一样，请重新输入','提示',{
                    confirmButtonText: '确定'
                })
            }else if(this.ruleForm.name == ''){
                this.$alert('请输入姓名','提示',{
                    confirmButtonText: '确定'
                })
            }else if(this.ruleForm.card_number == ''){
                this.$alert('请输入银行卡号','提示',{
                    confirmButtonText: '确定'
                })
            }else if(this.ruleForm.bank_name == ''){
                this.$alert('请输入开户银行','提示',{
                    confirmButtonText: '确定'
                })
            }else if(this.ruleForm.phone == ''){
                this.$alert('请输入手机号','提示',{
                    confirmButtonText: '确定'
                })
            }else if(this.ruleForm.vsCard_number == this.ruleForm.card_number){
                let data = {
                    bank_name: this.ruleForm.bank_name,
                    card_number: this.ruleForm.card_number,
                    name: this.ruleForm.name,
                    phone: this.ruleForm.phone
                }
                this.$store.dispatch('personal/CardUpdateUser',data)
                    .then(res => {
                        if(res.ok){
                            this.listByUser()

                            this.$notify({
                                title: '提示',
                                message: '保存成功',
                                type: 'success'
                            })
                        }
                    })
            }
        }
    
    },
    mounted(){
        
       
    },
    created(){
        let widthNew = document.documentElement.clientWidth
        if(widthNew > 540){
            this.widthNew = true
        }else{
            this.widthNew = false
        }
        this.listByUser()
        localStorage.setItem('active','2-7')
    }
}
</script>


<style scoped>
@import url(../../css/personal.css);

::v-deep .address-info .el-input__inner{
    border: none !important;
}
::v-deep .address-info .el-form-item {
    margin-bottom: 40px !important;
    padding-bottom: 16px !important;
    border-bottom: 0.5px solid #f2f2f2 !important;
}
::v-deep .address-info .el-form-item__error{
    padding-left: 15px !important;
}

.bookingItems{
    margin: 10px 0 20px 0;
    padding: 10px 10px 25px 10px;
   
}


.bookingItems .address-info{
    width: 770px;
    margin: 20px auto;
}
.bookingItems .address-info .el-input{
    width: 488px;
    height: 42px;
}

.restButtonForget{
   width: 232px;height: 40px;
   margin-left: 40px;
   background: #4095e5;
   color: #ffffff;
   border: 1px solid #4095e5;
   margin-top: 20px;
   align-items: center;
}
.tipsSpan{
    margin-left: 50px;
    font-size: 16px;
    color: #666;
}
.tipsP{
    margin: 5px 0 0 50px;
    font-size: 17px;
    color: #ff0000;
}
.cardUserInfo{
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 20px 20px 20px;
    margin-bottom: 20px;
    border-bottom: 0.5px solid #f2f2f2;
}
.cardUserInfo span{
    color: #4095e5;
}

@media screen and (max-width: 540px) {
    .currTitle{
        font-size: 20px;
    }
    .bookingItems{
        width: 100%;
        font-size: 16px;
        margin: 10px auto;
        margin: 10px 0 20px 0;
        padding: 10px 0px 25px 0px;
    
    }


    .bookingItems .address-info{
        width: 100%;
    }
    .bookingItems .address-info .el-input{
        width: 250px;
        height: 42px;
    }
    .restButtonForget{
        margin-left: 10px;
    }
    .tipsSpan{
        margin-left: 10px;
        font-size: 16px;
        color: #666;
    }
    .tipsP{
        margin: 5px 0 0 10px;
        font-size: 17px;
        color: #ff0000;
    }


}
</style>